module.exports = __webpack_public_path__ + "img/icon_trade-zoom.ea3df240.svg";